import React from 'react'
import Heroimg from "../../assets/images/hero-bg.png"
import Used1 from "../../assets/images/used01.png"
import Used2 from "../../assets/images/used02.png"
import Used3 from "../../assets/images/used03.png"
import Used4 from "../../assets/images/used04.png"
import Bannerimg from "../../assets/images/bannerimage1.png"
import Bannerimg2 from "../../assets/images/bannerimage2.png"
import Bannerimg3 from "../../assets/images/bannerimage3.png"
import Bannerimg4 from "../../assets/images/bannerimage4.png"



function Banner() {
    return (
        <>
            <section className="banner_section home-gredient">
                <div className="hero_bg"> <img src={Heroimg} alt="image" /> </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12" data-aos="fade-right" data-aos-duration="1500">
                            <div className="banner_text">
                                <h1>Best way to <span>manage your customers.</span></h1>
                                <p>Lorem Ipsum is simply dummy text of the printing and setting indus orem Ipsum has been the industrys.
                                </p>
                            </div>

                            <div className="trial_box">
                                <form action="" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="100">
                                    <div className="form-group">
                                        <input type="email" className="form-control" placeholder="Enter your email" />
                                    </div>
                                    <div className="form-group">
                                        <button className="btn">SUBMIT</button>
                                    </div>
                                </form>
                            </div>
                            <div className="trial_box_list">
                                <ul>
                                    <li><i className="icofont-check-circled"></i> Free trial 14 days</li>
                                    <li><i className="icofont-check-circled"></i> No credit card require</li>
                                </ul>
                            </div>

                            <div className="used_app">
                                <ul>
                                    <li><img src={Used1} alt="image" /></li>
                                    <li><img src={Used2} alt="image" /></li>
                                    <li><img src={Used3} alt="image" /></li>
                                    <li><img src={Used4} alt="image" /></li>
                                </ul>
                                <p>12M + <br /> used this app</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6" data-aos="fade-in" data-aos-duration="1500">
                            <div className="banner_images image_box1">
                                <span className="banner_image1"> <img className="moving_position_animatin" src={Bannerimg} alt="image" /> </span>
                                <span className="banner_image2"> <img className="moving_animation" src={Bannerimg2} alt="image" /> </span>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6" data-aos="fade-in" data-aos-duration="1500">
                            <div className="banner_images image_box2">
                                <span className="banner_image3"> <img className="moving_animation" src={Bannerimg3} alt="image" /> </span>
                                <span className="banner_image4"> <img className="moving_position_animatin" src={Bannerimg4} alt="image" /> </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Banner